export enum Score {
  ENVIRONMENT,
  SOCIAL,
  GOVERNANCE,
  TOTAL,
}
